<template>
  <div class="relative fit">
    <span v-if="value.strikethrough !== null" class="strikethrough">{{ value.strikethrough }}</span>
    <span class="price" :class="value.price == '-' ? 'price-mobile-position' : ''">{{ value.price }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: {
        price: null,
        strikethrough: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.strikethrough {
  position: absolute;
  top: 0;
  text-decoration: line-through;
  font-size: 14px;
  color: $text-gray;
  line-height: 1.5em;
}

@media(max-width: 768px) {
  .strikethrough{
    position: relative;
    display: block;
    margin-top: 0.6rem;
  }

  .price-mobile-position{
    display: block;
    line-height: 13vw;
    padding-right: 35px;
  }
}
</style>
